namespace GeniuzPOS.ReportMasterData {
    export class Report_1103Columns {
        static columnsKey = 'ReportMasterData.Report_1103';
    }
}
